export const apiOrgMemberRoleList = ["MEMBER", "OWNER"] as const

export const apiOrgMemberStatusList = [
    "ACTIVE",
    "INVITED",
    "INACTIVE",
    "DELETED"
] as const

export type APIOrgMemberRole = typeof apiOrgMemberRoleList[number]

export type APIOrgMemberStatus = typeof apiOrgMemberStatusList[number]

export interface APIOrgMember {
    id: number
    orgUsername: string
    accepted: string | null
    created: string
    invited: string
    orgId: number
    role: APIOrgMemberRole
    status: APIOrgMemberStatus
    userId: number
    userEmail: string
}

export function getOrgId(model: APIOrgMember): string {
    return String(model.id)
}
